import { Box, Typography } from "@mui/material";
import React from "react";
import {ArrowForward as ArrowForwardIcon,} from '@mui/icons-material';
import ButtonField from "./ButtonField";


interface OptionCardProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    actionLabel: string;
    onClick: () => void;
    disabled?: boolean;
    variant?: 'primary' | 'secondary';
    primaryHex: string;
    fontFamily?: string;
}

const OptionCard: React.FC<OptionCardProps> = ({
    icon,
    title,
    description,
    actionLabel,
    onClick,
    disabled,
    variant = 'secondary',
    primaryHex,
    fontFamily,
}) => {
    const isPrimary = variant === 'primary';
    return (
        <Box
            sx={{
                p: 2.5,
                borderRadius: 2,
                border: '1px solid',
                borderColor: isPrimary ? primaryHex : 'grey.300',
                bgcolor: isPrimary ? `${primaryHex}08` : 'background.paper',
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                transition: 'box-shadow 0.2s',
                '&:hover': { boxShadow: '0 4px 16px rgba(0,0,0,0.10)' },
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <Box
                    sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        bgcolor: isPrimary ? primaryHex : `${primaryHex}1a`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                >
                    {React.cloneElement(icon as React.ReactElement, {
                        sx: { color: isPrimary ? 'white' : primaryHex, fontSize: 20 },
                    })}
                </Box>
                <Box>
                    <Typography variant="subtitle1" fontWeight="700" fontFamily={fontFamily} color="text.primary">
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" fontFamily={fontFamily} sx={{ mt: 0.5 }}>
                        {description}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ButtonField
                    label={actionLabel}
                    variant={isPrimary ? 'contained' : 'outlined'}
                    className="font-bold"
                    onClick={onClick}
                    disabled={disabled}
                    endIcon={<ArrowForwardIcon />}
                />
            </Box>
        </Box>
    );
};


export default OptionCard;